import {  Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import { getUserNewDetails } from '../../../utils/localStorage';

const AuthorityLetter = () => {
    const [user, setUser] = useState<any>(null);

    useEffect(() => {
        setUser(JSON.parse(getUserNewDetails()));
    },[]);

    return (
        <Box>
            <Typography align="center" component="h1" ><strong>Authority Letter</strong></Typography>
            <Typography component="p">To,</Typography>
            <Typography component="p">LendenClub.com (Owned & operated by Innofin Solutions Private Limited)</Typography>
            <Typography component="p">Unit No. 5, Mezzanine Floor DLH Park, S V Road, Goregaon West</Typography>
            <Typography component="p">Mumbai, Maharashtra, India, - 400062 </Typography>
            <br></br>
            <Typography component="p" align="justify"><strong>Subject: {''}</strong>Authority to sign/collect documents and authorization to initiate collection/recovery against borrowers </Typography>
            <Typography component="p" align="justify">
                I, {user?.full_name} a registered lender with LenDenClub (www.lendenclub.com), an online platform operated by Innofin Solutions Pvt Ltd, an NBFC-P2P registered with the Reserve Bank of India, with User ID (“Lender”), hereby authorises Innofin Solutions Private Limited (“LenDenClub”): (i) to sign and execute the loan agreement to be entered with the borrower from time to time (copy of which has been provided to me); and (ii) to collect cheques from the borrower, on my behalf I further authorise you to initiate legal action against any borrower in case of default in payment or non-payment by the borrower for more than 30 days as and when the need arises and on such fees as may be mutually agreed between LenDenClub and myself. 
            </Typography>
            <Typography component="p" align="justify">
            I further confirm that I am liable and bound by all acts committed and obligations incurred under the above authorisation given to LenDenClub. LenDenClub shall have no obligations whatsoever while conducting any activity under this authorisation letter. 
            </Typography>
            <Typography component="p" align="justify">
            This authority letter shall cease to be in effect from the date on which the Lender ceases to be registered as a lender with www.LenDenClub.com 
            </Typography>
            <Typography component="p">
            Yours faithfully, 
            </Typography>
            <Typography component="p">{user?.full_name}</Typography>
        </Box>
    )
}

export default AuthorityLetter